export default __webpack_public_path__ + "static/media/Inventory-disposal.8a75bdab.svg";